// @flow

import React from 'react';
import Box from 'components/Box';
import { Body, BodyLarge, RichText } from 'components/Text';
import type { BlockquoteBlockData } from 'api/cms';

const BlockquoteBlock = ({
  data: { quote, cite }
}: {
  data: BlockquoteBlockData
}) => (
  <RichText>
    <Box component="blockquote">
      <BodyLarge dangerouslySetInnerHTML={{ __html: quote }} />
      {cite && (
        <Box mt="18px">
          <Body>{cite}</Body>
        </Box>
      )}
    </Box>
  </RichText>
);
export default BlockquoteBlock;
